"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blocks = _interopRequireDefault(require("markup-it/lib/constants/blocks"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  types: [_blocks.default.OL_LIST, _blocks.default.UL_LIST],
  typeItem: _blocks.default.LIST_ITEM,
  typeDefault: _blocks.default.PARAGRAPH
};
exports.default = _default;